import { render, staticRenderFns } from "./ChatFiltersConfigRules.vue?vue&type=template&id=297de883&scoped=true&"
import script from "./ChatFiltersConfigRules.vue?vue&type=script&lang=ts&"
export * from "./ChatFiltersConfigRules.vue?vue&type=script&lang=ts&"
import style0 from "./ChatFiltersConfigRules.vue?vue&type=style&index=0&id=297de883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297de883",
  null
  
)

export default component.exports